module.exports = __webpack_public_path__ + "img/revolts_3.c7945ca.jpg";